__turbopack_context__.v({
  "description": "Contact-module-scss-module__MsBtDG__description",
});
